import {NgModule} from '@angular/core';
import {ServiceUnavailableComponent} from './service-unavailable/service-unavailable.component';
import {ErrorPagesRoutingModule} from '../../routes/error-pages-routing.module';
import {BetriebNotFoundComponent} from './betrieb-not-found/betrieb-not-found.component';
import * as JFErrorPages from '@adnova/jf-ng-components';


@NgModule({
  imports: [
    ErrorPagesRoutingModule,
    JFErrorPages.ErrorPagesModule,
  ],
  declarations: [
    ServiceUnavailableComponent,
    BetriebNotFoundComponent,
  ],
  exports: [
    BetriebNotFoundComponent
  ]
})
export class ErrorPagesModule {
}
